import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getBorder, getCssClasses, getIsHidden, getMargin, getPadding, getTextAlign, getVerticalAlignment, getMediaQueries } from '../../utils';
export default (function (node) {
  var navigationEl = node.childNodes[0];
  var headerEls = navigationEl.childNodes;
  var headers = Array.from(headerEls, function (headerEl) {
    return headerEl.textContent;
  });
  var contentEl = node.childNodes[1];
  var alignmentMatch = /tab-align-([a-zA-Z]*)/.exec(node.getAttribute('class'));
  var tabNavigationAlignment = alignmentMatch ? alignmentMatch[1] : null;
  return _objectSpread({
    defaultIndex: node.getAttribute('data-active-tab') ? parseInt(node.getAttribute('data-active-tab'), 10) : 0,
    minHeight: contentEl.style.minHeight,
    tabNavigationAlignment: tabNavigationAlignment || 'left',
    headers: headers
  }, getVerticalAlignment(node), getMargin(node), getTextAlign(contentEl), getPadding(node), getBorder(contentEl), getIsHidden(node), getCssClasses(node), getMediaQueries(contentEl));
});